import React from 'react';

export function ProfileIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeWidth="1.5"
        d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M4 18a6 6 0 0 1 12 0"
      />
    </svg>
  );
}
